var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPencilLight = function SvgPencilLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m28.061 9.525-5.586-5.586a1.5 1.5 0 0 0-2.125 0l-3.704 3.707L4.94 19.354a1.49 1.49 0 0 0-.44 1.06V26A1.5 1.5 0 0 0 6 27.5h5.586a1.5 1.5 0 0 0 1.06-.439L28.06 11.646a1.5 1.5 0 0 0 0-2.125zM11.936 26.354a.5.5 0 0 1-.35.146H6a.5.5 0 0 1-.5-.5v-5.586a.5.5 0 0 1 .146-.354L17 8.706 23.293 15zm15.418-15.415L24 14.293 17.708 8l3.352-3.354a.5.5 0 0 1 .707 0l5.587 5.585a.503.503 0 0 1 0 .708"
  })));
};
export default SvgPencilLight;